import React from "react";
import { HashLink } from "react-router-hash-link";

const PaymentPage = () => {
  const transactions = [
    { name: "NETFLIX B.V.", amount: "-14,99€", date: "17/10/2024" },
    { name: "AMAZON EU S.A R.L.", amount: "-2,59€", date: "09/10/2024" },
    { name: "APPLE INC.", amount: "-11,99€", date: "24/09/2024" },
    { name: "GOOGLE IRELAND LTD", amount: "-4,99€", date: "21/09/2024" },
    { name: "VODAFONE", amount: "-7,89€", date: "11/09/2024" },
  ];

  return (
    <div className="p-4">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <HashLink className="text-blue-500 text-sm" to="/demo">
          Back
        </HashLink>

        <h1 className="text-lg font-bold text-blue-500">Payment</h1>
        <button className="text-blue-500 text-sm">?</button>
      </div>

      {/* Payment Card */}
      <div className="bg-blue-100 rounded-xl p-6 mb-6 shadow-lg h-[180px]">
        <div className="flex justify-between items-center">
          <h2 className="text-blue-500 font-bold text-xl">Mario Rossi</h2>
          <div className="h-8 w-12 bg-gradient-to-r from-orange-400 to-red-500 rounded-md"></div>
        </div>
        <p className="text-blue-500 mt-8">08/28</p>
        <p className="text-blue-500 mt-1">xxxx xxxx xxxx 3240</p>
      </div>

      {/* Last Transactions */}
      <div className="mb-6">
        <h2 className="text-blue-500 text-md font-bold mb-4">
          Last transactions
        </h2>
        {transactions.map((transaction, index) => (
          <div
            key={index}
            className="flex justify-between items-center py-3 border-b border-gray-200"
          >
            <div>
              <p className="text-sm font-bold text-blue-500">
                {transaction.name}
              </p>
              <p className="text-xs text-gray-400">{transaction.date}</p>
            </div>
            <p className="text-sm text-blue-500 font-bold">
              {transaction.amount}
            </p>
          </div>
        ))}
      </div>

      {/* Footer Buttons */}
      <div className="flex justify-around items-center mt-6">
        <button className="h-14 w-14 bg-blue-100 rounded-full flex justify-center items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-blue-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9.75 9.75h4.5m-2.25 8.25v-8.25m8.25-1.5v9a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 18.75v-9M16.5 6a2.25 2.25 0 10-4.5 0v.75M15 12H9"
            />
          </svg>
        </button>
        <button className="px-6 py-2 bg-blue-200 text-blue-500 font-bold rounded-lg">
          Manage Card
        </button>
        <button className="h-14 w-14 bg-blue-100 rounded-full flex justify-center items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-blue-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5.121 17.804A2 2 0 014 16.305V9a2 2 0 012-2h1M14 6a2 2 0 012 2v7.305a2 2 0 01-.879 1.499l-4 2.666a2 2 0 01-2.242 0l-4-2.666M14 10h2"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default PaymentPage;
